import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.message = '404 Page Not Found';
  }
};
default_1 = __decorate([Component({
  name: 'Page404'
})], default_1);
export default default_1;